import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { InviteStatus } from '../enums/invite-status';
import { InviteType } from '../enums/invite-type';

const InviteRecord = Record({
  type: 0,
  status: 0,
  token: '',
  company: {
    name: '',
    id: 0,
  },
  network: {
    name: '',
    id: 0,
  },
  team: {
    name: '',
    id: 0,
    default: false,
  },
  inviter: {
    name: '',
    comopanyName: '',
  },
});

export default class Invite extends InviteRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {};

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new Invite(hydrated);
  }

  isUsed() {
    return this.status !== InviteStatus.pending;
  }

  isCompanyInvite() {
    return this.type === InviteType.company;
  }

  isTeamInvite() {
    return this.type === InviteType.team;
  }

  isTeamMemberInvite() {
    return this.type === InviteType.teamMember;
  }

  isDefaultTeamInvite() {
    return this.isTeamMemberInvite() && this.team.default;
  }
}
